export default [
    "PFPF",
    "PFF",
    "HF"
];
